<template>
  <div>
    <div v-if="loading" class="table__spinnerWrapper">
      <app-spinner></app-spinner>
    </div>
    <v-container v-else>
      <v-row>
        <v-col md="2" v-if="!loading">
          <app-image-input-file :srcImage="newUser.image" :createFeature="false" :imgHeight="170" :imgWidth="150"
            :placeHolder="$t('personal picture')" @fileValue="newUser.image = $event"></app-image-input-file>
        </v-col>
        <v-col md="10" class="d-flex flex-column align-space-between">
          <div>
            <v-row>
              <v-col md="4">
                <v-text-field outlined dense v-model="newUser.name" :label="$t('name')"></v-text-field>
              </v-col>
              <v-col md="4" v-if="userType == 'admin'">
                <v-text-field outlined dense v-model="newUser.username" :label="$t('user name')"></v-text-field>
              </v-col>
              <v-col md="4" v-if="userType == 'admin'">
                <v-text-field outlined dense v-model="newUser.password" :label="$t('password')"></v-text-field>
              </v-col>
              <v-col md="4" v-if="userType == 'parent'">
                <v-text-field outlined dense hide-details v-model="newUser.phone" :label="$t('phone number')"
                  type="number"></v-text-field>
              </v-col>
            </v-row>
          </div>
          <v-autocomplete v-if="userType == 'parent'"   outlined 
            :label="$t('Add Child')"  :items="childrens" :loading="childrensLoading" color="#757575" item-text="name"
            item-value="id" v-model="newChilld"  @keypress="fetchRegRecordAutoComplete($event)"
            @input="inputChild" return-object  >
          </v-autocomplete>
          
            <v-col v-if="userType == 'parent'">
              <h2>{{ $t('child') }}</h2>

            </v-col>
            <!-- <v-col>
              <v-row v-if="(userType == 'parent') && (newUser.children != null)">
                <v-col md="1">{{ $t('id') }}</v-col>
                <v-col md="6">{{ $t('name') }}</v-col>
              </v-row>
            </v-col> -->
            <v-col v-if="userType == 'parent' " v-for="(el,ix) in newUser.children" :key="ix">
              <v-row>
                <v-col md="1" class="center">
                <h4>  {{ el.id }} </h4>
                </v-col>
                <v-col md="6" class="center">
                <h4>  {{ el.name }} </h4>
                </v-col>
                <v-col md="2">
                <v-icon @click="delChild(ix)" color="red">mdi-delete</v-icon>
              </v-col>
              </v-row>

            </v-col>
        </v-col>
        <v-col md="12">
          <v-btn depressed color="green" class="white--text" @click="addUser" :loading="submitBtnLoading">{{ $t('edit')
}}</v-btn>
        </v-col>

        <!-- <v-container v-if="userType == 'admin'">
          <div v-if="loadingAbilities" class="table__spinnerWrapper">
            <app-spinner></app-spinner>
          </div>
          <v-row v-else>
            <v-col md="12">
              <v-radio-group :dark="$store.state.isDarkMode"  row v-model="radioGroup" @change="handleRadioCases">
                <v-radio :label="$t('powers')" value="abilities"></v-radio>
                <v-radio :label="$t('roles')" value="roles"></v-radio>
              </v-radio-group>
            </v-col>
            <template v-if="radioGroup == 'abilities'">
              <v-col md="4" v-for="(value, key, idx) of abilities" :key="idx">
                <v-card class="add-user__chips-wrapper_Up">
                  <v-card-title class="justify-center">
                    <h2>{{ key }}</h2>
                  </v-card-title>
                  <v-card-text class="d-flex flex-column justify-center align-center">
                    <div  v-for="(ability, idx) in abilities[key]" :key="idx + 1" class="add-user__chip_Up">
                      <v-switch :true-value="true" :false-value="false" :input-value="selectedAbility(ability)"
                        color="green" @change="handleSwitchValue($event, ability)"></v-switch>
                      {{ ability.name }}
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </template>
            <v-col md="6" v-if="radioGroup == 'roles'">
              <v-autocomplete :label="$t('roles')" outlined dense hide-details :items="roles" item-text="name"
                item-value="id" v-model="newUser.roleId"></v-autocomplete>
            </v-col>
          </v-row>
        </v-container> -->

      </v-row>
    </v-container>
  </div>
</template>

<script>
import imageInputFile from "../../../../components/base/imageInputFile.vue";
import { mapMutations } from "vuex";
import axios from "axios";
import debounce from "../../../../helpers/debounce";

export default {
  components: {
    appImageInputFile: imageInputFile,
  },
  data() {
    return {
      loading: false,
      newChilld: null,
      radioGroup: "abilities",
      submitBtnLoading: false,
      childrensLoading: false,
      childrens: [],
      loadingAbilities: false,
      // either admin or parent
      userType: this.$route.params.userType,
      userId: this.$route.params.id,
      newUser: {
        name: null,
        username: null,
        password: null,
        image: null,
        children: [],
        roleId: null,
        password: null,
      },
      abilities: {},
      toBeSubmittedAbilitites: {},
      copyToBeSubmittedAbilities: {},
    };
  },
  methods: {
    delChild(i){
      this.newUser.children.splice(i,1);
    },
    selectedAbility(ability) {
      return this.toBeSubmittedAbilitites.hasOwnProperty(ability.id);
    },
    handleRadioCases(radioValue) {
      if (radioValue == "roles") {
        this.toBeSubmittedAbilitites = {};
      } else {
        this.toBeSubmittedAbilitites = { ...this.copyToBeSubmittedAbilities };
        this.newUser.roleId = null;
      }
    
    },
    handleSwitchValue(switchVal, ability) {
      let abilityId = ability.id;
      if (switchVal) {
        this.toBeSubmittedAbilitites[abilityId] = true;
      } else {
        delete this.toBeSubmittedAbilitites[abilityId];
      }
    },
    async addUser() {
    
      try {
        this.submitBtnLoading = true;
        let endPoint = "";
        let requestBody = {};
        if (this.newUser.image && typeof this.newUser.image != "string") {
          requestBody.image = this.newUser.image;
        }

        requestBody.name = this.newUser.name;
        requestBody.username = this.newUser.username;
        requestBody._method = "put";
        if (this.userType == "parent") {
          endPoint = `/parent/${this.userId}`;
          requestBody.phone = this.newUser.phone;
          requestBody.children = this.newUser.children;
        }
        if (this.userType == "admin") {
          if (this.newUser.password) {
            requestBody.password = this.newUser.password;
          }
          endPoint = `/user/${this.userId}`;
          if (Object.keys(this.toBeSubmittedAbilitites).length != 0) {
            requestBody.abilities = Object.keys(this.toBeSubmittedAbilitites);
          }
          if (this.newUser.roleId) {
            requestBody.role_id = this.newUser.roleId;
          }
        }
        let form = new FormData();
        for (let key in requestBody) {
          if (key == "abilities") {
            requestBody[key].forEach((abilityId, index) => {
              form.append(`ability[${index}]`, abilityId);
            });
            continue;
          }
          if (key == "children") {
            requestBody[key].forEach((childId, index) => {
              form.append(`children[${index}]`, childId.id);
            });
            continue;
          }
          form.append(`${key}`, requestBody[key]);
        }
        await axios.post(endPoint, form);
        this.$Notifications(
          this.$t('edit success'),
          { rtl: true, timeout: 1000 },
          "success"
        );
        this.$emit("submitted");
        if (this.userType == "admin") {
          this.$router.push("/admins");
        } else {
          this.$router.push("/parents");
        }
      } catch (err) {
        console.log("err", err);
      } finally {
        this.submitBtnLoading = false;
      }
    },
    inputChild(){
      this.newUser.children.push(this.newChilld);
      this.newChilld = null;
      this.childrens = null;
    },
    async fetchRegRecordAutoComplete(searchQuery) {
      debounce(async () => {
        let searchValue = searchQuery.target.value;
        this.childrensLoading = true;
        if (!searchValue) return;
        try {
          const searchResult = await axios.get("/student/auto-complete", {
            params: {
              name: searchValue,
              type: "parent",
            },
          });
          this.childrens = searchResult.data.data;
        } catch (err) {
          console.log("err", err);
        } finally {
          this.childrensLoading = false;
        }
      }, 1000)();
    },
    ...mapMutations({
      setRouteAddition: "setRouteNameAddition",
    }),
  },
  async created() {
    this.loading = true;
    if (this.userType == "admin") {
      try {
        this.loadingAbilities = true;
        // const abilities = await axios.get("/ability");
        const roles = await axios.get("/role", {
          params: {
            size: 10000,
          },
        });
        const user = await axios.get(`/user/${this.userId}`);
        this.roles = roles.data.data;
        // this.abilities = abilities.data;

        this.newUser.name = user.data.data.name;
        this.newUser.username = user.data.data.username;
        this.newUser.password = user.data.data.password;
        this.newUser.image = user.data.data.image;
        // user.data.data.data.forEach((ability) => {
        //   let abilityId = ability.id;
        //   this.toBeSubmittedAbilitites[abilityId] = true;
        // });
        // this.copyToBeSubmittedAbilities = { ...this.toBeSubmittedAbilitites };
      } catch (err) {
      } finally {
        this.loadingAbilities = false;
      }
    } else {
      try {
        
        const parent = await axios.get(`/parent/${this.userId}`);
        this.newUser.name = parent.data.data.name;
        this.newUser.username = parent.data.data.username;
        this.newUser.phone = parent.data.data.phone;
        this.newUser.image = parent.data.data.image;
        
        this.childrens = [...parent.data.data.children];
        this.childrens.forEach((el) => {
          this.newUser.children.push(el);
        });
      } catch (err) {
        console.log("err", err);
      } finally {
      }
    }
    this.loading = false;
  },
  beforeRouteLeave(to, from, next) {
    this.setRouteAddition(" ");
    next();
  },
  watch: {
    $route: {
      handler: function (to, from) {
        if (to.params.userType == "parent") this.setRouteAddition("أب");
        if (to.params.userType == "admin") this.setRouteAddition("مسؤول");
      },
      immediate: true,
    },
  },
};
</script>

<style>
.add-user__chips-wrapper_Up {
  /* max-height: 500px; */
  height: 470px;
  overflow: scroll;
  overflow-x: hidden;
  border: 1px solid #757575;
}

.add-user__chip_Up {
  border: 1px solid #757575;
  border-radius: 10px;
  margin: 5px 0;
  /* padding: 5px 0; */
  width: 100%;
  /* height: 70%; */
  color: var(--bg-color--font);
  display: flex;
  justify-content: space-around;
  align-items: center;
}
</style>